import { trySafe } from '@silverhand/essentials';
import * as s from 'superstruct';

const sessionRecoverySsrDataGuard = s.type({
  signInExperience: s.type({
    sessionRecoveryUri: s.string(),
  }),
});

const missingSessionFallbackPath = '/unknown-session';
const forgotPasswordPath = '/forgot-password';
const forgotPasswordIntent = 'forgot-password';

export const getSessionRecoveryTarget = (ssrData: unknown, pathname: string): string => {
  const [error, parsed] = s.validate(ssrData, sessionRecoverySsrDataGuard);

  if (error) {
    return missingSessionFallbackPath;
  }

  const { sessionRecoveryUri } = parsed.signInExperience;

  return (
    trySafe(() => {
      const recoveryUrl = new URL(sessionRecoveryUri);

      if (!['http:', 'https:'].includes(recoveryUrl.protocol)) {
        return;
      }

      if (pathname.startsWith(forgotPasswordPath)) {
        recoveryUrl.searchParams.set('auth_flow', forgotPasswordIntent);
      }

      return recoveryUrl.href;
    }) ?? missingSessionFallbackPath
  );
};

export const recoverFromMissingSession = () => {
  window.location.replace(getSessionRecoveryTarget(logtoSsr, window.location.pathname));
};
